<template>
<div class='bodyer recharge success'>
    <div class='yi-title-nav'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-2 title'>
                    <i class='icon iconfont icon-chongzhi2 float-left'></i>充值结果
                </div>
                <div class='col-md-10'>
                    <a class='yi-btn white-o sm float-right'
                        href='/#/recharge/log'>查询记录</a>
                </div>
            </div>
        </div>
    </div>
    <div class='banner'>
        <img src='/static/image/recharge/banner.jpg'>
    </div>
    <div class='main'>
        <div class='container'>
            <div class='title'>充值结果</div>
            <div class='content row'>
                <div class='col-md-3'>
                    <ul class='list-group nav'>
                        <li class='list-group-item' :class='trade.channel == "ali" ? "active" : ""'>
                            <img class='icon' src='/static/image/recharge/icon-ali.png'>
                            支付宝充值
                        </li>
                        <li class='list-group-item' :class='trade.channel == "wx" ? "active" : ""'>
                            <img class='icon' src='/static/image/recharge/icon-wx.png'>
                            微信充值
                        </li>
                    </ul>
                </div>
                <div class='col-md-9'>
                    <div>
                        <div class='row box-result'>
                            <div class='col-md-9 trade-info'>
                                <ul>
                                    <li>您充值的业务：{{trade.amount/100}}应答币</li>
                                    <li>充值帐号：{{user.username}}</li>
                                    <li>订单号：{{trade.number}}</li>
                                </ul>
                            </div>
                            <div class='col-md-3'>
                                <div class='amount text-danger'>总金额：{{trade.amount/100}}元</div>
                            </div>
                        </div>
                        <div class='box-tip'>
                            <div class='img'>
                                <img src='/static/image/recharge/result-success.png'>
                            </div>
                            <div class='text text-danger'>支付成功</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script type="text/javascript">
import Request from '@/common/Request'
import Common from '@/common/Common'
import Storage from '@/common/Storage'
import Notify from '@/common/Notify'
export default {
    data : function(){
        return {
            'trade' : {}
        }
    },
    props : ['user'],
    created : function(){
        window.scrollTo(0, 0)
        if(!this.user){
            Common.toUrl('/login')
            return true
        }
        var trade = Storage.get('trade', false)
        if(!trade){
            Common.toUrl('/')
            return true
        }
        this.trade = trade
    }
}
</script>



// WEBPACK FOOTER //
// src/components/recharge/Success.vue